import { Card } from '@/components/ui/card';
import ManageBookingTable from './table'
import useDocumentTitle from '@/components/ui/common/document-title';

const FacailityBooking = () => {
  useDocumentTitle("Booking Management");
  
  return (
    <div className="w-full p-2 sm:p-4 md:p-5">
      <Card className="pt-4">
        <ManageBookingTable />
      </Card>
    </div>
  )
}

export default FacailityBooking